// extracted by mini-css-extract-plugin
export default {"error404":"style--error404--04afad","logo":"style--logo--5221be","textblock":"style--textblock--41887a"};